<template>
    <div>
        <pc-input
            id="MetadataNameTextbox"
            ref="MetadataNameTextbox"
            v-model="newName"
            v-bind:label="metadataNameLabel"
            v-bind:validator="requiredValidator"
            required
            validation-enabled
            class="mb-2"
            v-on:validated="onValidated($event)" />
        <pc-select
            id="MetadataTypeSelect"
            ref="MetadataTypeSelect"
            v-model="newType"
            v-bind:label="metadataTypeLabel"
            v-bind:disabled="!enableTypeInput"
            v-bind:validation-enabled="enableTypeInput"
            v-bind:validator="requiredValidator"
            required
            class="mb-2"
            v-on:validated="onValidated($event)">
            <option value="">
                {{ metadataTypeSelectorPrompt }}
            </option>
            <option v-bind:value="textDataType">
                {{ textDataTypeText }}
            </option>
            <option v-bind:value="decimalDataType">
                {{ decimalDataTypeText }}
            </option>
        </pc-select>
        <pc-select
            id="MetadataOrderSelect"
            v-model="newOrder"
            v-bind:label="metadataOrderLabel"
            v-bind:options="orderOptions"
            required />
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/editIncentiveMetadataFieldDialog.i18n";
    import { VALIDATOR_TYPES, getValidator } from "Validation/validator";
    import { DIALOG_RESULT } from "Components/pc-dialog.vue";
    import { METADATA_TYPE } from "./incentiveDesignList.vue";

    export default {
        props: {
            metadataName: { type: String, required: true },
            metadataType: { type: String, required: true },
            enableTypeInput: { type: Boolean, required: true },
            metadataOrder: { type: String, required: true },
            maxOrderNumber: { type: Number, required: true }
        },
        data() {
            return {
                newName: this.metadataName,
                newType: this.metadataType,
                newOrder: this.metadataOrder,
                requiredValidator: getValidator(this.$app, VALIDATOR_TYPES.required),
                hasError: false
            };
        },
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            ),
            textDataType() {
                return METADATA_TYPE.Text;
            },
            decimalDataType() {
                return METADATA_TYPE.Decimal;
            },
            orderOptions() {
                const ooArray = [];
                for (let o = 1; o <= this.maxOrderNumber; o++) {
                    const oo = { text: o.toString(), value: o.toString() };
                    ooArray.push(oo);
                }
                return ooArray;
            }
        },
        methods: {
            onValidated(result) {
                this.hasError = this.hasError || result.hasError;
            },
            verifyCanClose(result) {
                if (result === DIALOG_RESULT.cancel) {
                    return true;
                }
                // newOrder always has a valid value
                this.hasError = false;
                this.$refs.MetadataNameTextbox.validate();
                this.$refs.MetadataTypeSelect.validate();
                return !this.hasError;
            },
            resultHook() {
                return {
                    NewName: this.newName,
                    NewType: this.newType,
                    NewOrder: this.newOrder
                };
            }
        }
    };
</script>
